var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_50_2720)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67698 11.196L11.6725 8.61513C12.1954 9.31314 12.0839 10.2469 11.3969 10.8396L9.66252 12.3349C8.37633 13.4439 6.24825 13.4439 4.96412 12.3349C3.67863 11.2281 3.67863 9.39322 4.96412 8.28685L11.6725 2.5C12.1954 3.20023 12.0796 4.13609 11.3969 4.72635L8.05817 7.60557C7.88725 7.75239 7.88725 7.99246 8.05817 8.13973C8.22755 8.28863 8.50641 8.28863 8.67698 8.13973L11.6725 5.55624C12.1954 6.25691 12.0839 7.19055 11.3969 7.78258L8.05817 10.6621C7.88725 10.8092 7.88725 11.0488 8.05817 11.196C8.22755 11.3449 8.50641 11.3449 8.67698 11.196Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_2720",
    x1: -13.44,
    y1: -13.3244,
    x2: 22.4314,
    y2: 12.3132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.561865,
    stopColor: "#F4E334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58D2B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngel);
export default __webpack_public_path__ + "static/media/angel.77274739df8da1e165220aca4ad55b40.svg";
export { ForwardRef as ReactComponent };